import { useEffect, useRef } from 'react';
import { t } from '../../i18n';
import { useToast } from '../../lib/toast';
import { threadId } from './common/store';
import { allContacts, appChat, appOpenThread, unreadOf } from './data';

// Zahl ungelesener Nachrichten von der Kanzlei (alle Firmen), live.
// Wird einmal im Rahmen der App benutzt und zeigt dort auch die Meldung „Neue Nachricht von …“:
// nicht für Nachrichten, die beim Laden schon da waren, und nicht für den gerade offenen Chat.
export function useChatUnread(): number {
  const data = appChat.useData();
  const open = appOpenThread.useOpen();
  const toast = useToast();
  const seenUntil = useRef<string | null>(null);

  useEffect(() => {
    if (!data) return;
    const incoming = allContacts(data).filter((c) => c.lastIncoming);
    const newest = incoming.reduce((a, c) => (c.lastIncoming!.at > a ? c.lastIncoming!.at : a), '');
    if (seenUntil.current === null) {
      seenUntil.current = newest;
      return;
    }
    const since = seenUntil.current;
    const fresh = incoming
      .filter((c) => c.lastIncoming!.at > since && threadId(c.clientId, c.id) !== appOpenThread.get())
      .sort((a, b) => b.lastIncoming!.at.localeCompare(a.lastIncoming!.at));
    if (fresh[0]) toast(t('Neue Nachricht von {name}', { name: fresh[0].name }));
    if (newest > since) seenUntil.current = newest;
  }, [data, toast]);

  return allContacts(data).reduce((n, c) => n + unreadOf(c, open), 0);
}
